import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=700df8bf&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('700df8bf')) {
      api.createRecord('700df8bf', component.options)
    } else {
      api.reload('700df8bf', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=700df8bf&", function () {
      api.rerender('700df8bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gnBZojaBZHuV/JS/offershelp.vue"
export default component.exports